import type * as Types from 'app/types/graphql';

export type CampaignGroupSelectFragment = Pick<
  Types.CampaignGroup,
  | 'id'
  | 'type'
  | 'title'
  | 'status'
  | 'priority'
  | 'trafficRate'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
> & {
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.CampaignGroupVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export type CampaignGroupEdgeSelectFragment = Pick<Types.CampaignGroupEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.CampaignGroup,
      | 'id'
      | 'type'
      | 'title'
      | 'status'
      | 'priority'
      | 'trafficRate'
      | 'targetDevices'
      | 'targetChannels'
      | 'targetCountries'
      | 'targetVisitorTypes'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'startedAt'
    > & {
      campaigns?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.Campaign,
              | 'id'
              | 'name'
              | 'type'
              | 'status'
              | 'priority'
              | 'storeDomain'
              | 'targetDevices'
              | 'targetChannels'
              | 'targetCountries'
              | 'targetVisitorTypes'
              | 'conditions'
              | 'createdAt'
              | 'updatedAt'
              | 'startedAt'
              | 'deletedAt'
              | 'completedAt'
            > & {
              product?: Types.Maybe<
                Pick<
                  Types.CampaignProduct,
                  'id' | 'baseID' | 'title' | 'image' | 'handle' | 'createdAt' | 'updatedAt'
                >
              >;
              variants?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.Variant,
                      | 'id'
                      | 'isOrigin'
                      | 'isWinner'
                      | 'trafficRate'
                      | 'themePageID'
                      | 'templateType'
                      | 'templateSuffix'
                      | 'createdAt'
                      | 'deletedAt'
                      | 'updatedAt'
                      | 'winnerTemplateSuffix'
                    > & {
                      template?: Types.Maybe<
                        Pick<
                          Types.VariantTemplate,
                          | 'createdAt'
                          | 'deletedAt'
                          | 'id'
                          | 'redirectURL'
                          | 'themeID'
                          | 'updatedAt'
                          | 'thumbnailURL'
                          | 'title'
                        >
                      >;
                      price?: Types.Maybe<
                        Pick<
                          Types.VariantPrice,
                          | 'id'
                          | 'baseID'
                          | 'handle'
                          | 'status'
                          | 'title'
                          | 'redirectURL'
                          | 'sourceProductBaseID'
                        >
                      >;
                      productVariants?: Types.Maybe<
                        Array<
                          Types.Maybe<
                            Pick<
                              Types.VariantProductVariant,
                              'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                            >
                          >
                        >
                      >;
                      url?: Types.Maybe<
                        Pick<
                          Types.VariantUrl,
                          'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
                        >
                      >;
                    }
                  >
                >
              >;
              group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
              versions?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.SplitTestingCampaignVersion,
                      'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
                    >
                  >
                >
              >;
            }
          >
        >
      >;
      versions?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.CampaignGroupVersion,
              'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
            >
          >
        >
      >;
    }
  >;
};

export type CampaignGroupWithChildrenSelectFragment = Pick<
  Types.CampaignGroup,
  | 'id'
  | 'type'
  | 'title'
  | 'status'
  | 'priority'
  | 'trafficRate'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
> & {
  campaigns?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Campaign,
          | 'id'
          | 'name'
          | 'type'
          | 'status'
          | 'priority'
          | 'storeDomain'
          | 'targetDevices'
          | 'targetChannels'
          | 'targetCountries'
          | 'targetVisitorTypes'
          | 'conditions'
          | 'createdAt'
          | 'updatedAt'
          | 'startedAt'
          | 'deletedAt'
          | 'completedAt'
        > & {
          product?: Types.Maybe<
            Pick<
              Types.CampaignProduct,
              'id' | 'baseID' | 'title' | 'image' | 'handle' | 'createdAt' | 'updatedAt'
            >
          >;
          variants?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.Variant,
                  | 'id'
                  | 'isOrigin'
                  | 'isWinner'
                  | 'trafficRate'
                  | 'themePageID'
                  | 'templateType'
                  | 'templateSuffix'
                  | 'createdAt'
                  | 'deletedAt'
                  | 'updatedAt'
                  | 'winnerTemplateSuffix'
                > & {
                  template?: Types.Maybe<
                    Pick<
                      Types.VariantTemplate,
                      | 'createdAt'
                      | 'deletedAt'
                      | 'id'
                      | 'redirectURL'
                      | 'themeID'
                      | 'updatedAt'
                      | 'thumbnailURL'
                      | 'title'
                    >
                  >;
                  price?: Types.Maybe<
                    Pick<
                      Types.VariantPrice,
                      | 'id'
                      | 'baseID'
                      | 'handle'
                      | 'status'
                      | 'title'
                      | 'redirectURL'
                      | 'sourceProductBaseID'
                    >
                  >;
                  productVariants?: Types.Maybe<
                    Array<
                      Types.Maybe<
                        Pick<
                          Types.VariantProductVariant,
                          'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                        >
                      >
                    >
                  >;
                  url?: Types.Maybe<
                    Pick<
                      Types.VariantUrl,
                      'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
                    >
                  >;
                }
              >
            >
          >;
          group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
          versions?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.SplitTestingCampaignVersion,
                  'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
                >
              >
            >
          >;
        }
      >
    >
  >;
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.CampaignGroupVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export type CampaignGroupVersionSelectFragment = Pick<
  Types.CampaignGroupVersion,
  'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
>;

export const CampaignGroupVersionSelectFragmentDoc = `
    fragment CampaignGroupVersionSelect on CampaignGroupVersion {
  id
  version
  settings
  startedAt
  completedAt
}
    `;
export const CampaignGroupSelectFragmentDoc = `
    fragment CampaignGroupSelect on CampaignGroup {
  id
  type
  title
  status
  priority
  trafficRate
  targetDevices
  targetChannels
  targetCountries
  targetVisitorTypes
  conditions
  createdAt
  updatedAt
  startedAt
  versions {
    ...CampaignGroupVersionSelect
  }
}
    `;
export const CampaignGroupWithChildrenSelectFragmentDoc = `
    fragment CampaignGroupWithChildrenSelect on CampaignGroup {
  ...CampaignGroupSelect
  campaigns {
    ...CampaignWithProductSelect
  }
}
    `;
export const CampaignGroupEdgeSelectFragmentDoc = `
    fragment CampaignGroupEdgeSelect on CampaignGroupEdge {
  cursor
  node {
    ...CampaignGroupWithChildrenSelect
  }
}
    `;
